const expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
const regex = new RegExp(expression);

export default function parseUrls(text: string, spaceAfter = false): string[] {
  const urls = text.match(regex) || [];
  if (spaceAfter) {
    return urls.filter(url => new RegExp(`${url}[ \r\n]`, 'g').test(text));
  }
  return urls;
}
